/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
*/

  // Bundle quantity sync: when Set qty changes, update all items with same bundle_id (single atomic request)
  var bundleSyncInProgress = false;
  var bundleSyncLastDone = 0;
  var BUNDLE_SYNC_COOLDOWN_MS = 1200;
  var bundleCartNeedsRecovery = false;
  function isBundleQuantityLeader(lineItemEl) {
    if (!lineItemEl) return false;
    if (lineItemEl.classList && lineItemEl.classList.contains('line-item__bundle-set-header')) return true;
    var bundleComponent = lineItemEl.getAttribute('data-bundle-component');
    return bundleComponent === 'Set' || lineItemEl.getAttribute('data-bundle-leader') === 'true';
  }
  function getBundleLeaderElement(fromEl) {
    if (!fromEl || !fromEl.closest) return null;
    var lineItem = fromEl.closest('.line-item, line-item');
    if (lineItem && isBundleQuantityLeader(lineItem)) return lineItem;
    var header = fromEl.closest('.line-item__bundle-set-header');
    return header || null;
  }
  function syncBundleQuantity(lineItemEl, newQuantity) {
    var now = Date.now();
    if (bundleSyncInProgress || (now - bundleSyncLastDone) < BUNDLE_SYNC_COOLDOWN_MS) return false;
    if (!isBundleQuantityLeader(lineItemEl)) return false;
    var bundleId = lineItemEl.getAttribute('data-bundle-id');
    if (!bundleId) return false;
    var updates = {};
    var allLineItems = document.querySelectorAll('.line-item, line-item');
    for (var i = 0; i < allLineItems.length; i++) {
      if (allLineItems[i].getAttribute('data-bundle-id') === bundleId) {
        var key = allLineItems[i].getAttribute('data-item-key');
        var line = allLineItems[i].getAttribute('data-line');
        if (key) updates[key] = newQuantity;
        else if (line) updates[line] = newQuantity;
      }
    }
    if (Object.keys(updates).length === 0) return false;
    bundleSyncInProgress = true;
    var updateUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '/update.js';
    var cartUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
    var isCartPage = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart';
    var done = function() { bundleSyncInProgress = false; bundleSyncLastDone = Date.now(); };
    var finishWithCart = function(cart) {
      var safeCart = (cart && Array.isArray(cart.items)) ? cart : { item_count: 0, items: [] };
      lineItemEl.dispatchEvent(new CustomEvent('line-item-quantity:change:end', { bubbles: true, detail: { cart: safeCart, newLineQuantity: newQuantity } }));
      if (cart && Array.isArray(cart.items)) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, replacementDelay: newQuantity === 0 ? 600 : 750 } }));
      }
      if (isCartPage) window.location.href = cartUrl;
    };
    lineItemEl.dispatchEvent(new CustomEvent('line-item-quantity:change:start', { bubbles: true, detail: { newLineQuantity: newQuantity } }));
    var body = { updates: updates };
    if (!isCartPage) body.sections = ['mini-cart'];
    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function(r) {
      return r.text().then(function(text) {
        if (!r.ok) {
          var err = { ok: false, status: r.status };
          try { err = JSON.parse(text); } catch (e) {}
          return Promise.reject(err);
        }
        try { return JSON.parse(text); } catch (e) { return Promise.reject(new Error('Invalid JSON')); }
      });
    }).then(function(cart) {
      done();
      if (cart && Array.isArray(cart.items)) {
        bundleCartNeedsRecovery = false;
        finishWithCart(cart);
      } else {
        bundleCartNeedsRecovery = true;
        fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); }).then(finishWithCart).catch(function() { finishWithCart(null); });
      }
    }).catch(function() {
      done();
      bundleCartNeedsRecovery = true;
      fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); }).then(finishWithCart).catch(function() { finishWithCart(null); });
    });
    return true;
  }

  document.addEventListener('click', function(event) {
    var removeLink = event.target.closest && event.target.closest('.line-item__remove-button');
    if (removeLink && removeLink.href && bundleCartNeedsRecovery) {
      event.preventDefault();
      event.stopPropagation();
      var lineItem = removeLink.closest('.line-item, line-item');
      var bundleId = lineItem && lineItem.getAttribute('data-bundle-id');
      if (bundleId) {
        var updates = {};
        var all = document.querySelectorAll('.line-item, line-item');
        for (var i = 0; i < all.length; i++) {
          if (all[i].getAttribute('data-bundle-id') === bundleId) {
            var key = all[i].getAttribute('data-item-key');
            var line = all[i].getAttribute('data-line');
            if (key) updates[key] = 0;
            else if (line) updates[line] = 0;
          }
        }
        if (Object.keys(updates).length > 0) {
          var cartUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
          fetch(cartUrl + '/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ updates: updates })
          }).then(function(r) { return r.json(); }).then(function(cart) {
            if (cart && Array.isArray(cart.items)) {
              bundleCartNeedsRecovery = false;
              document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
            } else {
              window.location.href = removeLink.href;
            }
          }).catch(function() {
            window.location.href = removeLink.href;
          });
          return;
        }
      }
      window.location.href = removeLink.href;
      return;
    }
    var qtyLink = event.target.closest && event.target.closest('a[href*="cart/change"]');
    if (qtyLink) {
      var lineItem = getBundleLeaderElement(qtyLink);
      if (lineItem) {
        event.preventDefault();
        event.stopPropagation();
        var url = new URL(qtyLink.href, window.location.origin);
        var newQty = parseInt(url.searchParams.get('quantity'), 10);
        if (!isNaN(newQty) && newQty >= 0) syncBundleQuantity(lineItem, newQty);
        return;
      }
    }
    var target = event.target;
    var paymentBtn = target.closest && target.closest('.shopify-payment-button');
    if (!paymentBtn) return;
    var buyButtons = paymentBtn.closest && paymentBtn.closest('[data-bundle-discount-code]');
    var discountCode = buyButtons && buyButtons.getAttribute('data-bundle-discount-code');
    if (!discountCode) return;
    event.preventDefault();
    event.stopPropagation();
    var form = paymentBtn.closest('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    var id = idInput && idInput.value;
    var quantity = (qtyInput && (parseInt(qtyInput.value, 10) || 1)) || 1;
    var sellingPlan = (sellingPlanInput && sellingPlanInput.value) || null;
    if (!id) return;
    var body = { id: parseInt(id, 10), quantity: quantity };
    if (sellingPlan) body.selling_plan = parseInt(sellingPlan, 10);
    var cartAddUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartAddUrl) || '/cart/add';
    fetch(cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) { return r.json(); }).then(function(data) {
      if (data.status && data.status !== 200) return Promise.reject(data);
      return fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '.js');
    }).then(function(r) { return r.json(); }).then(function(cart) {
      var codes = (cart.cart_level_discount_applications || []).map(function(d) { return (d.code || d.title || '').trim(); }).filter(Boolean);
      var codeLower = discountCode.trim().toLowerCase();
      if (!codes.some(function(c) { return c.toLowerCase() === codeLower; })) codes.push(discountCode.trim());
      return fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });
    }).then(function(r) { return r.json(); }).then(function(cart) {
      var root = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.rootUrl) || '/';
      var codes = (cart && cart.cart_level_discount_applications) ? (cart.cart_level_discount_applications || []).map(function(d) { return (d.code || d.title || '').trim(); }).filter(Boolean) : [];
      var codeLower = discountCode.trim().toLowerCase();
      if (!codes.some(function(c) { return c.toLowerCase() === codeLower; })) codes.push(discountCode.trim());
      var checkoutUrl = root.replace(/\/?$/, '') + '/checkout?discount=' + encodeURIComponent(codes.join(','));
      window.location.href = checkoutUrl;
    }).catch(function(err) {
      var msg = (err && (err.description || err.message)) || 'Something went wrong';
      if (typeof msg === 'string') alert(msg);
    });
  }, true);

  document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input || input.getAttribute('name') !== 'updates[]') return;
    var lineItemQuantity = input.closest && input.closest('line-item-quantity');
    var lineItem = getBundleLeaderElement(lineItemQuantity || input);
    if (!lineItem) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var newQty = parseInt(input.value, 10);
    if (!isNaN(newQty) && newQty >= 0) syncBundleQuantity(lineItem, newQty);
  }, true);

  // Theme adds components only; legacy Set product lines in the same bundle_id override checkout pricing.
  var legacySetLineCleanupInProgress = false;
  function removeLegacyBundleSetProductLines(cart) {
    if (!cart || !Array.isArray(cart.items) || legacySetLineCleanupInProgress || bundleSyncInProgress) return false;
    var bundleHasComponents = {};
    var setLinesToRemove = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var props = item.properties || {};
      var bid = (props._bundle_id || props.bundle_id || '').toString();
      if (!bid) continue;
      var comp = (props._bundle_component || props.bundle_component || '').toString();
      if (comp === 'product') bundleHasComponents[bid] = true;
      else if (comp === 'Set') setLinesToRemove.push({ key: item.key, bundleId: bid });
    }
    var updates = {};
    for (var s = 0; s < setLinesToRemove.length; s++) {
      if (bundleHasComponents[setLinesToRemove[s].bundleId]) {
        updates[setLinesToRemove[s].key] = 0;
      }
    }
    if (!Object.keys(updates).length) return false;
    legacySetLineCleanupInProgress = true;
    fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function(r) { return r.json(); }).then(function(updatedCart) {
      legacySetLineCleanupInProgress = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: updatedCart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
    }).catch(function() { legacySetLineCleanupInProgress = false; });
    return true;
  }

  // Failsafe: remove duplicate Set line items (same bundle_id should have only 1 Set)
  var duplicateSetCleanupInProgress = false;
  function removeDuplicateBundleSets(cart) {
    if (!cart || !Array.isArray(cart.items) || duplicateSetCleanupInProgress || bundleSyncInProgress) return false;
    var bundleIdToSets = {};
    var bundleIdToAllItems = {};
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var props = item.properties || {};
      var bundleId = (props._bundle_id || props.bundle_id || '').toString();
      var component = (props._bundle_component || props.bundle_component || '').toString();
      if (!bundleId) continue;
      if (!bundleIdToAllItems[bundleId]) bundleIdToAllItems[bundleId] = [];
      bundleIdToAllItems[bundleId].push(item);
      if (component === 'Set') {
        if (!bundleIdToSets[bundleId]) bundleIdToSets[bundleId] = [];
        bundleIdToSets[bundleId].push({ key: item.key, quantity: item.quantity });
      }
    }
    var updates = {};
    for (var bid in bundleIdToSets) {
      var sets = bundleIdToSets[bid];
      if (sets.length > 1) {
        var totalQty = 0;
        for (var j = 0; j < sets.length; j++) totalQty += sets[j].quantity;
        updates[sets[0].key] = totalQty;
        for (var k = 1; k < sets.length; k++) updates[sets[k].key] = 0;
        var allItems = bundleIdToAllItems[bid] || [];
        for (var m = 0; m < allItems.length; m++) {
          var it = allItems[m];
          var comp = (it.properties || {})._bundle_component || (it.properties || {}).bundle_component;
          if (comp !== 'Set') {
            updates[it.key] = totalQty;
          }
        }
      }
    }
    if (Object.keys(updates).length === 0) return false;
    duplicateSetCleanupInProgress = true;
    var cartUrl = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
    var isCartPage = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart';
    var body = { updates: updates };
    if (!isCartPage) body.sections = ['mini-cart'];
    fetch(cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function(r) { return r.json(); }).then(function(updatedCart) {
      duplicateSetCleanupInProgress = false;
      if (updatedCart && Array.isArray(updatedCart.items)) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: updatedCart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
        if (isCartPage) window.location.href = cartUrl;
      }
    }).catch(function() {
      duplicateSetCleanupInProgress = false;
    });
    return true;
  }

  // Apply bundle discount code to cart when product has bundle_discount_code metafield
  // Preserves existing discount codes so multiple can be active (e.g. Mixed Size Set + Morgan bundle code)
  function getExistingDiscountCodes(cart) {
    if (!cart || !cart.cart_level_discount_applications) return [];
    return cart.cart_level_discount_applications.map(function(d) {
      return (d.code || d.title || '').trim();
    }).filter(Boolean);
  }

  function cartHasDiscountCode(cart, discountCode) {
    if (!cart || !discountCode) return false;
    var codeLower = discountCode.trim().toLowerCase();
    return (cart.cart_level_discount_applications || []).some(function(d) {
      return ((d.code || d.title || '').trim().toLowerCase()) === codeLower;
    });
  }

  function getCartUpdateUrl() {
    return (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '/update.js';
  }

  function getCartJsonUrl() {
    return (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '.js';
  }

  function ensureBundleDiscountApplied(discountCode, cart, attempt) {
    if (!discountCode) return Promise.resolve(cart || null);
    attempt = attempt || 0;
    function applyDiscount(currentCart) {
      if (cartHasDiscountCode(currentCart, discountCode)) return Promise.resolve(currentCart);
      var codes = getExistingDiscountCodes(currentCart);
      var codeLower = discountCode.trim().toLowerCase();
      if (!codes.some(function(c) { return c.toLowerCase() === codeLower; })) codes.push(discountCode.trim());
      return fetch(getCartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function(res) {
        return res.json().then(function(updatedCart) {
          if (res.status === 429 && attempt < 4) {
            return new Promise(function(resolve) {
              setTimeout(function() {
                resolve(ensureBundleDiscountApplied(discountCode, null, attempt + 1));
              }, 500 * (attempt + 1));
            });
          }
          if (res.ok && updatedCart && Array.isArray(updatedCart.items)) return updatedCart;
          return currentCart;
        });
      }).catch(function() { return currentCart; });
    }
    if (cart && Array.isArray(cart.items)) return applyDiscount(cart);
    return fetch(getCartJsonUrl(), { cache: 'no-store', credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(applyDiscount)
      .catch(function() { return null; });
  }

  window.kilteEnsureBundleDiscount = ensureBundleDiscountApplied;

  function applyBundleDiscountIfNeeded(cart, discountCode) {
    if (!discountCode || cartHasDiscountCode(cart, discountCode)) return;
    ensureBundleDiscountApplied(discountCode, cart).then(function(updatedCart) {
      if (!updatedCart || updatedCart === cart) return;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: updatedCart } }));
    });
  }

  document.addEventListener('variant:added', function(event) {
    var form = event.target;
    var discountCode = form && form.closest && form.closest('[data-bundle-discount-code]') && form.closest('[data-bundle-discount-code]').getAttribute('data-bundle-discount-code');
    if (!discountCode) return;
    fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { applyBundleDiscountIfNeeded(cart, discountCode); })
      .catch(function() { /* ignore */ });
  });

  // Run duplicate Set cleanup on initial load (catches cart with duplicates from before)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function runOnce() {
      document.removeEventListener('DOMContentLoaded', runOnce);
      fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { removeDuplicateBundleSets(cart); })
        .catch(function() { /* ignore */ });
    });
  } else {
    fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { removeDuplicateBundleSets(cart); })
      .catch(function() { /* ignore */ });
  }

  // Bundle cart order: Set above children (flex order)
  function applyBundleCartOrder() {
    var list = document.querySelector('#mini-cart-form .line-item-list');
    if (list) applyBundleCartOrderToList(list);
  }
  function applyBundleCartOrderToList(list) {
    if (list.querySelector('.line-item__bundle-set-header, .line-item__bundle-set-header-row')) return;
    var children = Array.prototype.slice.call(list.children);
    var orderMap = {};
    var displayIndex = 0;
    var bundleToSetIndex = {};
    var bundleToChildren = {};
    var includesToBundle = {};
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el.classList && (el.classList.contains('line-item__bundle-includes') || el.classList.contains('line-item__bundle-includes-row'))) {
        var next = el.nextElementSibling;
        var nextBid = next && next.getAttribute && next.getAttribute('data-bundle-id');
        if (nextBid) includesToBundle[i] = nextBid;
        continue;
      }
      if (el.classList && (el.classList.contains('line-item__bundle-set-header') || el.classList.contains('line-item__bundle-set-header-row'))) {
        var headerBid = el.getAttribute && el.getAttribute('data-bundle-id');
        if (headerBid) {
          if (bundleToSetIndex[headerBid] === undefined) {
            bundleToSetIndex[headerBid] = -1;
            bundleToChildren[headerBid] = [];
          }
          bundleToSetIndex[headerBid] = i;
        }
        continue;
      }
      var bid = el.getAttribute && el.getAttribute('data-bundle-id');
      var comp = el.getAttribute && el.getAttribute('data-bundle-component');
      if (!bid) {
        orderMap[i] = displayIndex++;
        continue;
      }
      if (bundleToSetIndex[bid] === undefined) {
        bundleToSetIndex[bid] = -1;
        bundleToChildren[bid] = [];
      }
      if (comp === 'Set') bundleToSetIndex[bid] = i;
      else if (comp === 'product' && el.getAttribute && el.getAttribute('data-bundle-leader') === 'true') {
        if (bundleToSetIndex[bid] < 0) bundleToSetIndex[bid] = i;
      } else if (comp === 'product') bundleToChildren[bid].push(i);
    }
    var bundleIds = Object.keys(bundleToSetIndex);
    bundleIds.sort(function(a, b) {
      var sa = bundleToSetIndex[a] >= 0 ? bundleToSetIndex[a] : 9999;
      var sb = bundleToSetIndex[b] >= 0 ? bundleToSetIndex[b] : 9999;
      return sa - sb;
    });
    for (var b = 0; b < bundleIds.length; b++) {
      var bid = bundleIds[b];
      var setIdx = bundleToSetIndex[bid];
      var childIndices = bundleToChildren[bid] || [];
      if (setIdx >= 0) orderMap[setIdx] = displayIndex++;
      var incIdx = -1;
      for (var k in includesToBundle) if (includesToBundle[k] === bid) { incIdx = parseInt(k, 10); break; }
      if (incIdx >= 0) orderMap[incIdx] = displayIndex++;
      for (var c = 0; c < childIndices.length; c++) orderMap[childIndices[c]] = displayIndex++;
    }
    for (var j = 0; j < children.length; j++) {
      children[j].style.order = String(orderMap[j] !== undefined ? orderMap[j] : displayIndex++);
    }
  }
  function scheduleBundleCartOrder(ms) {
    setTimeout(applyBundleCartOrder, ms || 100);
  }
  document.addEventListener('DOMContentLoaded', function() { scheduleBundleCartOrder(100); });
  document.addEventListener('cart:refresh', function(event) {
    var delay = (event.detail && event.detail.replacementDelay) || 750;
    scheduleBundleCartOrder(delay + 200);
    scheduleBundleCartOrder(delay + 600);
  });
  document.addEventListener('cart:updated', function() { scheduleBundleCartOrder(100); });
  if (typeof MutationObserver !== 'undefined') {
    var orderTimeout;
    function debouncedOrder() {
      clearTimeout(orderTimeout);
      orderTimeout = setTimeout(applyBundleCartOrder, 50);
    }
    document.addEventListener('DOMContentLoaded', function() {
      var cartDrawer = document.querySelector('cart-drawer, #mini-cart');
      if (cartDrawer) {
        var mo = new MutationObserver(debouncedOrder);
        mo.observe(cartDrawer, { childList: true, subtree: true });
      }
    });
  }

  // Cart display count: exclude non-leader bundle products; count Set/leader lines + standalone items
  function getCartDisplayCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var count = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var props = cart.items[i].properties || {};
      var comp = (props._bundle_component || props.bundle_component || '').toString();
      if (comp === 'product' && (props._bundle_leader || '').toString() !== 'true') continue;
      count += cart.items[i].quantity || 0;
    }
    return count;
  }
  function patchCartForDisplayCount(event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    var displayCount = getCartDisplayCount(cart);
    event.detail.cart.item_count = displayCount;
  }
  document.addEventListener('cart:updated', patchCartForDisplayCount, true);
  document.addEventListener('cart:refresh', patchCartForDisplayCount, true);

  var BUNDLE_SET_CART_LIMIT = 5;
  var BUNDLE_SET_LIMIT_NOTICE_ENABLED = false;

  function getCartLineProperty(props, key) {
    if (!props) return '';
    if (typeof props === 'object' && !Array.isArray(props)) {
      return props[key] != null ? String(props[key]) : '';
    }
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i++) {
        var entry = props[i] || {};
        var name = entry.name || entry.key || entry.first;
        if (name === key) return entry.value != null ? String(entry.value) : (entry.last != null ? String(entry.last) : '');
      }
    }
    return '';
  }

  function countBundleSetsInCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var seen = {};
    var total = 0;
    cart.items.forEach(function(item) {
      var props = item.properties || {};
      var bundleId = getCartLineProperty(props, '_bundle_id');
      var component = getCartLineProperty(props, '_bundle_component');
      var isLeader = getCartLineProperty(props, '_bundle_leader') === 'true';
      if (!bundleId || component !== 'product' || !isLeader || seen[bundleId]) return;
      seen[bundleId] = true;
      total += item.quantity || 1;
    });
    return total;
  }

  function syncBundleSetLimitNotice(cart) {
    if (!BUNDLE_SET_LIMIT_NOTICE_ENABLED) {
      document.querySelectorAll('.bundle-set-cart-limit-notice').forEach(function(el) {
        el.remove();
      });
      return;
    }
    if (countBundleSetsInCart(cart) >= BUNDLE_SET_CART_LIMIT) return;
    document.querySelectorAll('.bundle-set-cart-limit-notice').forEach(function(el) {
      el.remove();
    });
  }
  function syncBundleSetTitleLinks(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var urlByBundleId = {};
    cart.items.forEach(function(item) {
      var props = item.properties || {};
      var bid = props._bundle_id;
      if (!bid) return;
      if (!urlByBundleId[bid]) urlByBundleId[bid] = {};
      if (props._bundle_set_url) urlByBundleId[bid].url = String(props._bundle_set_url);
      if (props._bundle_set_handle) urlByBundleId[bid].handle = String(props._bundle_set_handle);
      if (props._bundle_set_title) urlByBundleId[bid].title = String(props._bundle_set_title);
    });
    document.querySelectorAll('.line-item__bundle-set-header, .line-item__bundle-set-header-row').forEach(function(header) {
      var bid = header.getAttribute('data-bundle-id');
      if (!bid || !urlByBundleId[bid]) return;
      var info = urlByBundleId[bid];
      var url = info.url || (info.handle ? '/products/' + info.handle : '');
      if (!url && info.title) url = '/products/' + info.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (!url) return;
      var titleEl = header.querySelector('.product-item-meta__title');
      if (!titleEl || titleEl.tagName === 'A') {
        if (titleEl && titleEl.tagName === 'A' && titleEl.getAttribute('href') !== url) titleEl.setAttribute('href', url);
        return;
      }
      var link = document.createElement('a');
      link.href = url;
      link.className = titleEl.className + ' link';
      link.style.cssText = 'margin: 0; text-transform: none; text-decoration: underline;';
      link.textContent = titleEl.textContent.trim();
      titleEl.replaceWith(link);
    });
  }
  function syncBundleSetCartUi(cart) {
    var run = function(resolvedCart) {
      syncBundleSetLimitNotice(resolvedCart);
      syncBundleSetTitleLinks(resolvedCart);
    };
    if (cart && Array.isArray(cart.items)) {
      run(cart);
      return;
    }
    fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl || '/cart') + '.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(run)
      .catch(function() { /* ignore */ });
  }
  document.addEventListener('cart:updated', function() {
    syncBundleSetCartUi();
  }, true);
  document.addEventListener('cart:refresh', function(event) {
    var delay = (event.detail && event.detail.replacementDelay) || 750;
    setTimeout(function() {
      syncBundleSetCartUi();
    }, delay + 150);
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    syncBundleSetCartUi();
  });

  // Fallback: apply discount when cart updates (catches edge cases)
  var lastBundleDiscountApply = 0;
  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail && event.detail.cart;
    if (removeLegacyBundleSetProductLines(cart)) return;
    if (removeDuplicateBundleSets(cart)) return;
    var discountEl = document.querySelector('[data-bundle-discount-code]');
    var discountCode = discountEl && discountEl.getAttribute('data-bundle-discount-code');
    if (!discountCode || !cart) return;
    if (cartHasDiscountCode(cart, discountCode)) return;
    var now = Date.now();
    if (now - lastBundleDiscountApply < 1500) return;
    lastBundleDiscountApply = now;
    applyBundleDiscountIfNeeded(cart, discountCode);
  });

  //Variant listener for pre-order variants
  document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details

    //Grab Variant Preorder JSON
    const preorderVariantData = JSON.parse(document.querySelector("#kilte-variant-preoder-json").textContent)

    //Find the chosen Variant
    const chosenVariant = preorderVariantData.find(v => {return v.id === variant.id})

    const addToCart = document.querySelector("#AddToCart")

    // Update selling_plan hidden input (Timesact / Shopify selling plan – required for pre-order cart add)
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput) {
      sellingPlanInput.value = (chosenVariant && chosenVariant.selling_plan_id) ? String(chosenVariant.selling_plan_id) : '';
    }

    // Pre-order button label only; shipping copy comes from Timesact (.timesact-selling-plan-description)
    if (chosenVariant && chosenVariant.hasPreorder) {
      if (addToCart && addToCart.firstElementChild) addToCart.firstElementChild.innerHTML = "Pre-order";
    }
    
    
  });
  

/**
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */